import { Component, Input, OnInit, ViewChild } from '@angular/core';
import {
  ApexChart,
  ChartComponent,
  ApexTooltip,
  ApexAxisChartSeries,
  ApexPlotOptions,
  ApexFill,
  ApexStroke,
  NgApexchartsModule,
  ApexDataLabels,
  ApexLegend,
  ApexGrid,
  ApexXAxis,
  ApexYAxis,
} from 'ng-apexcharts';

export type ChartOptions = {
  series: ApexAxisChartSeries;
  chart: ApexChart;
  dataLabels: ApexDataLabels;
  plotOptions: ApexPlotOptions;
  yaxis: ApexYAxis;
  xaxis: ApexXAxis;
  fill: ApexFill;
  tooltip: ApexTooltip;
  stroke: ApexStroke;
  legend: ApexLegend;
};



@Component({
  selector: 'app-barchart',
  templateUrl: './barChart.component.html',
})
export class AppbarChartComponent implements OnInit {
  @ViewChild('chart') chart: ChartComponent = Object.create(null);

  @Input() sale: string = ""
  @Input() showDataLabels: boolean = true;

  @Input() salesDataGraph: Array<any> = []
  @Input() categories: Array<any> = []
  public employeeChart!: Partial<ChartOptions> | any;

  constructor() {

  }

  onclick(){
    console.log("test")
  }
  async ngOnInit(): Promise<any> {
    
    this.employeeChart = {
      series: [
        {
          name: "Sale",
          data: this.salesDataGraph
        }
      ],
      chart: {
        type: "bar",
        height: 350,
        events: {
          click: this.onclick
        }
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: "80%",
          endingShape: "rounded",
          dataLabels: {
            hideOverflowingLabels: true,
            position: 'top', // top, center, bottom
            orientation: 'vertical', // horizontal, vertical
          },
        }
      },

      dataLabels: {
        enabled: this.showDataLabels,
        style: {
          fontSize: '12px',
          fontFamily: 'Helvetica, Arial, sans-serif',
          fontWeight: 'lighter',
          colors: ["#757575"]
        }
      },
      
      legend: {
        show: true,
        showForSingleSeries: true,
        customLegendItems: ["Actual", "Expected","Difference"],
        markers: {
          fillColors: ["#00E396", "#775DD0", "#FF4560"],
        }
      },
      stroke: {
        show: true,
        width: 2,
        colors: ["transparent"]
      },
      xaxis: {
        categories: this.categories
      },
      yaxis: {
        title: {
          text: "Price"
        }
      },
      fill: {
        opacity: 1
      },
      tooltip: {
        y: {
          formatter: function (val) {
            return val + "kr";
          }
        }
      }
    };
  }
}
